import { render, staticRenderFns } from "./InterrogateComponent.vue?vue&type=template&id=737c59d2&scoped=true"
import script from "./InterrogateComponent.vue?vue&type=script&lang=js"
export * from "./InterrogateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c59d2",
  null
  
)

export default component.exports